// @ts-expect-error ignore
__webpack_public_path__ = `${globalThis.crate.assetsBaseUrl}/`;
